import { render, staticRenderFns } from "./cTomIndex.vue?vue&type=template&id=e634de40&scoped=true&"
import script from "./cTomIndex.vue?vue&type=script&lang=js&"
export * from "./cTomIndex.vue?vue&type=script&lang=js&"
import style0 from "./cTomIndex.vue?vue&type=style&index=0&id=e634de40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e634de40",
  null
  
)

export default component.exports